import React, { useState, ChangeEvent } from 'react'
import { useAxios } from '@/context/axiosContext'
import { useAppDispatch } from '@/redux/hooks'
import { login } from '@/redux/slices/auth'
import { useNavigate } from 'react-router-dom'
import { useDialog } from '@/context/dialogContext'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  background: #b6b6b6;
`

const FormWrapper = styled.div`
  background-color: #fff;
  padding: 2rem 3rem;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
  margin-bottom: 10rem;
`

const Input = styled.input`
  width: 100%;
  padding: 0.75rem;
  margin-bottom: 1rem;
  border: 1px solid #d09d30;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: #d09d30;
  }
`

const Button = styled.button`
  width: 100%;
  padding: 0.75rem;
  font-size: 1rem;
  color: #ffffff;
  background-color: #d09d30;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgb(173, 132, 44);
  }

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`

const Footer = styled.div`
  margin-top: 1rem;
  text-align: center;
  font-size: 0.9rem;
  color: #777;

  a {
    color: #d09d30;
    text-decoration: none;
    font-weight: bold;

    &:hover {
      text-decoration: underline;
    }
  }
`

const Logo = styled.img`
  width: 300px;
  height: auto;
  margin: 10px 0px 50px;
`

const LoginPage = () => {
  const axios = useAxios()
  const { showAlert } = useDialog()
  const [form, setForm] = useState({ userId: '', password: '' })
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setForm({ ...form, [name]: value })
  }

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (form.userId.trim() === '' || form.userId.trim().length < 5) {
      showAlert({ type: 'warning', message: 'ID를 확인해주세요.' })
      return false
    } else if (form.password.trim() === '' || form.password.trim().length < 5) {
      showAlert({ type: 'warning', message: 'PW를 확인해주세요.' })
      return false
    }

    const response = await axios.post('/auth/login', form)
    if (response.data.common.resultCode === 'L0200') {
      dispatch(login({ ...response.data.data }))
      navigate('/main')
    } else {
      showAlert({
        type: 'error',
        message: `${response.data.common.resultCode}\n${response.data.common.resultMsg}`,
      })
    }
  }

  const isFormValid = () => {
    if (form.userId.trim() === '' || form.userId.trim().length < 5) {
      return false
    } else if (form.password.trim() !== '' || form.password.trim().length < 5) {
      return false
    }
    return true
  }

  return (
    <Container>
      <FormWrapper>
        <Logo src="/images/logo-neverbe.png" alt="Company Logo" />
        <form onSubmit={handleSubmit}>
          <Input
            type="text"
            name="userId"
            placeholder="아이디"
            value={form.userId}
            onChange={handleInputChange}
          />
          <Input
            type="password"
            name="password"
            placeholder="비밀번호"
            value={form.password}
            onChange={handleInputChange}
          />
          <Button type="submit" disabled={!isFormValid}>
            Login
          </Button>
        </form>
        <Footer>
          {/* <p>
            Forgot your password? <a href="#reset">Reset it here</a>.
          </p> */}
        </Footer>
      </FormWrapper>
    </Container>
  )
}

export default LoginPage
